import PropTypes from 'prop-types';
import React from 'react';
import { SurfacesContext } from 'js/analytics/autotest/AutotestAnalytics';

export class ImpactTopStat extends React.Component {
  static propTypes = {
    statCount: PropTypes.number.isRequired,
    statNoun: PropTypes.string.isRequired,
    mobile: PropTypes.bool,
  };

  statLabel = () => {
    return $h.pluralize(this.props.statCount, this.props.statNoun);
  };

  statCount = () => {
    if (this.props.loading) {
      return '\u2014'; // mdash
    } else {
      return $h.commaizeInt(this.props.statCount);
    }
  };

  render() {
    // Autotest KPI typography slot (defaults == the original utility classes).
    const kpi = this.context.kpiTileTypography;
    const statClassName = [
      kpi.fontSizeClass,
      kpi.lineHeightClass,
      kpi.weightClass,
      kpi.colorClass,
    ]
      .filter(Boolean)
      .join(' ');
    const labelClassName = [kpi.paddingClass, kpi.labelClass]
      .filter(Boolean)
      .join(' ');
    return (
      <div className={this.props.mobile ? '' : 'col-xs-4'}>
        <div className="panel panel-flat a-fadeInDown">
          <div className="panel-heading u-tcGrayDarker u-fs18 u-fw300 u-pv10x u-taCenter">
            <div className="u-clearfix">
              <span className={statClassName}>{this.statCount()}</span>
              <div className={labelClassName}>{this.statLabel()}</div>
            </div>
          </div>
        </div>
      </div>
    );
  }
}

ImpactTopStat.contextType = SurfacesContext;
